import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import utils from 'utils';
import { FooterLinks } from '../utils';
import { NEW_WINDOW_PROPS } from 'data/global';

export const useRenderLinks = () => {
  const { t } = useTranslation();

  const renderLinks = useCallback(
    (array: Array<FooterLinks>, externLink?: boolean) =>
      array.map(({ label, href, icon }) => (
        <li key={href} className="footer__section__link">
          {icon && utils.renderIcon(icon)}
          {externLink ? (
            <a href={href} aria-label={t(label)} {...NEW_WINDOW_PROPS}>
              {t(label)}
            </a>
          ) : (
            <Link to={href}>{t(label)}</Link>
          )}
        </li>
      )),
    [t],
  );

  return renderLinks;
};
